import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#666",
      d: "M16.797 11.263a.75.75 0 0 0-1.012-1.101l-.082.075-3.203 3.417-3.203-3.417a.75.75 0 0 0-.974-.104l-.086.07a.75.75 0 0 0-.104.974l.07.086 3.75 4a.75.75 0 0 0 1.009.078l.085-.078 3.75-4Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "down"}) } }